import { Typography, Card, Row, Col, Spin, Statistic } from 'antd';
import { DollarOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

const SalesMetrics = ({ data, loading, currentDateInfo, variant }) => {
  const metrics   = data || {};
  const isFinancial = variant === 'financial';
  const cardClass = isFinancial ? 'financial-card' : 'dashboard-card';

  const header = isFinancial ? (
    <span style={{ fontSize: '14px', fontWeight: 'bold' }}>
      <DollarOutlined style={{ marginRight: 6 }} />Resumen Financiero
    </span>
  ) : null;

  return (
    <Card
      className={cardClass}
      title={header}
      extra={isFinancial && currentDateInfo
        ? <span style={{ fontSize: '12px', color: '#888' }}>{currentDateInfo}</span>
        : null}
    >
      {!isFinancial && (
        <div className="card-header">
          <div className="card-icon card-icon-primary"><DollarOutlined /></div>
          <div>
            <Title level={4}>Resumen Financiero</Title>
            <Text type="secondary">{currentDateInfo}</Text>
          </div>
        </div>
      )}
      <div className={isFinancial ? undefined : 'card-content'}>
        {loading ? (
          <Spin />
        ) : (
          <>
            <Row gutter={[16, 16]}>
              <Col span={8}>
                <Statistic
                  title="Ingresos Totales de MXN"
                  value={parseFloat(metrics.total_sales_mxn || 0).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  prefix="$"
                  valueStyle={{ color: '#52c41a' }}
                />
              </Col>
              <Col span={8}>
                <Statistic
                  title="Ingresos Totales de USD"
                  value={parseFloat(metrics.total_sales_usd || 0).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  prefix="$"
                  valueStyle={{ color: '#52c41a' }}
                />
              </Col>
              <Col span={8}>

              </Col>
              <Col span={8}>
                <Statistic
                  title="Órdenes Totales"
                  value={metrics.total_orders || 0}
                  valueStyle={{ color: '#1890ff' }}
                />
              </Col>
              <Col span={8}>
                <Statistic
                  title="Clientes Atendidos"
                  value={metrics.total_clients || 0}
                  valueStyle={{ color: '#722ed1' }}
                />
              </Col>
              <Col span={8}>
                <Statistic
                  title="Categorías con Ventas"
                  value={metrics.total_categories || 0}
                  valueStyle={{ color: '#fa8c16' }}
                />
              </Col>
            </Row>

            {(metrics.sales_by_category || []).length > 0 && (
              <div style={{ marginTop: 20 }}>
                <div
                  style={{
                    display: 'flex',
                    fontWeight: 'bold',
                    marginTop: 10,
                    paddingBottom: 6,
                    borderBottom: '2px solid #e5e7eb'
                  }}
                >
                  <div style={{ width: '50%' }}>Ventas por Categoría:</div>
                  <div style={{ width: '25%', textAlign: 'right' }}>MXN</div>
                  <div style={{ width: '25%', textAlign: 'right' }}>USD</div>
                </div>

                <div style={{ marginTop: 8 }}>
                  {metrics.sales_by_category.map((category, index) => (
                    <div
                      key={index}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        padding: '8px 0',
                        borderBottom: '1px solid #f0f0f0'
                      }}
                    >
                      <div style={{ width: '50%' }}>
                        <Text>{category.name}</Text>
                      </div>
                      <div style={{ width: '25%', textAlign: 'right' }}>
                        <Text strong>
                          ${parseFloat(category.total_mxn || 0).toLocaleString('es-MX', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                          })}
                        </Text>
                      </div>
                      <div style={{ width: '25%', textAlign: 'right' }}>
                        <Text strong>
                          ${parseFloat(category.total_usd || 0).toLocaleString('es-MX', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                          })}
                        </Text>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </Card>
  );
};

export default SalesMetrics;
